import React, { useState } from "react";
import { Button, Col, Spinner } from "react-bootstrap";
import styled from "styled-components";
import $ from 'jquery';
import { generateResult } from "../../redux/slices/IdiqApiSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeliveryBot from "../../assets/img/robot-dab.gif";
import DisputeCycle from "../../assets/img/disputes_cycle.png"
import DisputeResultImage from "../../assets/img/bot_writting_stuff_down.png"
import { blankGetAllReportData } from "../../redux/slices/ReportSlice";
import { blankCurrentStatus } from "../../redux/slices/DashboardSlice";
import { blankUploadDocument } from "../../redux/slices/UploadDocumentSlice";
import { blankStartCurrentScore } from "../../redux/slices/DisputeCenterSlice";
import { updateProviderLogin } from "../../redux/slices/IdiqApiSlice";

const CountdownWrapper = styled.div`
  font-weight: bold;
  text-align: center;
  align-items: center;
  display: flex;
  width: 100% !important;
  margin: 0 14%;
`;

const CountdownItem = styled.div`
  display: inline-block;
  margin: 0 4px;
`;

const CountdownValue = styled.div`
  font-size: 60px;
  color: var(--bs-primary);
  width: min-content;
`;

const CountdownLabel = styled.div`
  font-size: 12px;
  font-weight: normal;
  margin-top: 5px;
`;

export default function CountdownTemplates({ status, data, notyf, callback }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isInvalidLogin, setIsInvalidLogin] = useState(false);


  let template = <></>;

  const getResult = async () => {
    setIsSubmitting(true);
    notyf.open({
      type: "success",
      message:
        "Disputely is Generating Your Result. Kindly wait and don't refresh...",
      duration: 6000,
      ripple: false,
      dismissible: false,
      position: {
        x: "right",
        y: "top",
      },
    });

    try {
      const res = await dispatch(generateResult()).unwrap();
      if(res.error === 0){
        notyf.open({
          type: "success",
          message: "Result Generated Successfully",
          duration: 5000,
          ripple: false,
          dismissible: false,
          position: {
            x: "right",
            y: "top",
          },
        });
        dispatch(blankCurrentStatus())
        dispatch(blankGetAllReportData())
        if (window.location.href.includes("dispute-center")) {
          dispatch(blankUploadDocument())
          dispatch(blankStartCurrentScore())
          callback();
        } else {
          navigate("/dispute-center", {
            state: { toItems: true },
          });
        }

        return
      }else if(["SSN_NOT_READY", "LOGINS_NOT_READY"].includes(res?.data?.code)){
        getLogin(res.provider_type, res.username)
      }


      notyf.open({
        type: "danger",
        message: res?.data?.message || res.msg,
        duration: 5000,
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
      setIsSubmitting(false);

      
    } catch (error) {
      notyf.open({
        type: "danger",
        message: error.message,
        duration: 5000,
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
      setIsSubmitting(false);
    }
  };

  const getLogin = async(provider, username) => {
    $.confirm({
      title: `Update your ${provider === "IDIQ" ? "Identity IQ": provider} login credential`,
      content: `
        <div>
          <div class="mb-3">
            <label for="loginUsername" class="form-label">Username</label>
            <input type="text" class="form-control" id="loginUsername" value="${username}" readonly>
          </div>
          <div class="mb-3">
            <label for="loginPass" class="form-label">Password</label>
            <input type="password" class="form-control" id="loginPass">
          </div>
          ${provider === "IDIQ" ? `
          <div class="mb-3">
            <label for="loginSSN" class="form-label">SSN</label>
            <input type="text" min-length="4" max-length="4" class="form-control" id="loginSSN">
          </div>` : ""}
          
        </div>`,
      buttons: {
        yes: {
          text: 'Submit',
          btnClass: 'btn-success',
          action: function () {
            this.buttons.yes.setText('Loading..'); // let the user know 
            this.buttons.yes.disable(); // disable more clicks
            this.buttons.no.disable(); // disable more clicks

            const that = this;
            (async()=>{
              let username = this.$content.find('#loginUsername').val(),
              password = this.$content.find('#loginPass').val(),
              ssn = this.$content.find('#loginSSN').val();
  
              if((provider === "IDIQ" && (!ssn.length || !password.length)) || !password.length){
                !ssn.length && that.$content.find('#loginPass').addClass('is-invalid');
                !password.length && that.$content.find('#loginSSN').addClass('is-invalid');
                that.buttons.yes.setText('Submit'); // let the user know 
                that.buttons.yes.enable(); // disable more clicks
                that.buttons.no.enable(); // disable more clicks
                return false
              }
  
              try{
                const rsp = await dispatch(updateProviderLogin({username,password, ssn})).unwrap();
                notyf.open({
                  type: "success",
                  message:`${provider === "IDIQ" ? "Identity IQ": provider} Login Creds Updated Successfully.`,
                  duration: 3000,
                  ripple: false,
                  dismissible: false,
                  position: {
                    x: "right",
                    y: "top",
                  },
                });
                that.close()
                getResult()
              }catch(err){
                notyf.open({
                  type: "danger",
                  message:`${provider === "IDIQ" ? "Identity IQ": provider} Login Creds Failed to Update. Try again`,
                  duration: 3000,
                  ripple: false,
                  dismissible: false,
                  position: {
                    x: "right",
                    y: "top",
                  },
                });
                that.buttons.yes.setText('Submit'); // let the user know 
                that.buttons.yes.enable(); // disable more clicks
                that.buttons.no.enable(); // disable more clicks
              }
            })()
            

            return false;
          },
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-danger',
          action: () => {},
        },
      },
    });
  }

  switch (status) {
    case "GENERATE_RESULTS":
      template = (
        <Col xs={12}>
          <div className="my-3 mx-auto p-3 border-primary border border-5 shadow rounded-4 w-80 d-flex justify-content-center">
            <CountdownWrapper className="mx-0 text-center d-flex flex-column justify-content-center">
              <h6 className="fw-bold">Congratulations your dispute cycle has completed! It's now time to view your results!</h6>
              {isSubmitting && (
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <div>
                    <img
                      src={DeliveryBot}
                      alt="Delivery Bot"
                      className="img-fluid"
                      style={{ maxWidth: 100 }}
                    />
                  </div>
                  <p className="fw-bold">
                    Give us a few seconds while we retrieve your latest credit
                    reports in order to compile your Dispute Cycle Results!
                  </p>
                </div>
              )}
              <div className="d-flex justify-content-between align-items-center">
                <Button
                    size="lg"
                    className="p-3 d-flex align-items-center gap-2"
                    disabled={isSubmitting}
                    onClick={(e) => {
                      getResult();
                    }}
                >
                  {isSubmitting && (<Spinner animation="border" size="md" />)}  GENERATE RESULTS
                </Button>
                <img src={DisputeResultImage} style={{width: 100}} alt="Read Result Bot" className="img-fluid"/>
              </div>
            </CountdownWrapper>
          </div>
        </Col>
      );
      break;

    case "COUNTDOWN":
      template = (
        <Col xs={12}>
          <div className="my-3 mx-auto p-3 border-primary border border-5 shadow rounded-4 w-80 d-flex justify-content-center">
            <CountdownWrapper>
              <CountdownItem>
                <CountdownValue id="days">
                  {data?.days.toString().length === 1 && "0"}
                  {data?.days}{" "}
                </CountdownValue>
                <CountdownLabel>Days</CountdownLabel>
              </CountdownItem>
              <CountdownItem>
                <CountdownValue>:</CountdownValue>
                <CountdownLabel>&nbsp;</CountdownLabel>
              </CountdownItem>
              <CountdownItem>
                <CountdownValue id="hours">
                  {data?.hours.toString().length === 1 && "0"}
                  {data?.hours}{" "}
                </CountdownValue>
                <CountdownLabel>Hours</CountdownLabel>
              </CountdownItem>
              <CountdownItem>
                <CountdownValue>:</CountdownValue>
                <CountdownLabel>&nbsp;</CountdownLabel>
              </CountdownItem>
              <CountdownItem>
                <CountdownValue id="mins">
                  {data?.minutes.toString().length === 1 && "0"}
                  {data?.minutes}{" "}
                </CountdownValue>
                <CountdownLabel>Mins</CountdownLabel>
              </CountdownItem>
              <CountdownItem>
                <CountdownValue>:</CountdownValue>
                <CountdownLabel>&nbsp;</CountdownLabel>
              </CountdownItem>
              <CountdownItem style={{ marginRight: "-1rem" }}>
                <CountdownValue id="secs">
                  {data?.seconds.toString().length === 1 && "0"}
                  {data?.seconds}
                </CountdownValue>
                <CountdownLabel
                  className="w-100 position-relative"
                  style={{ width: "80px !important" }}
                >
                  <span>Secs</span>
                </CountdownLabel>
              </CountdownItem>
            </CountdownWrapper>
          </div>
        </Col>
      );

      break;

    case "NEW_ROUND":
      template = (
        <Col xs={12}>
          <div className="my-3 mx-auto p-3 border-primary border border-5 shadow rounded-4 w-80 d-flex justify-content-center">
            <CountdownWrapper className="mx-0 text-center d-flex flex-column justify-content-center">
              <h6 className="fw-bold">You still have items that can be disputed for removal! Continue disputing your items to help improve your credit scores!</h6>
              <div className="d-flex justify-content-between align-items-center">
                <Button
                    size="lg"
                    className="p-3"
                    disabled={isSubmitting}
                    onClick={(e) => {
                      const currentT = e.currentTarget;
                      (async () => {
                        currentT.disabled = true;
                        navigate("/report-audit-round");
                      })();
                    }}
                  >
                    START NEW DISPUTE CYCLE
                </Button>
                <img src={DisputeCycle} style={{width: 100}} alt="Read Result Bot" className="img-fluid"/>
              </div>
            </CountdownWrapper>
          </div>
        </Col>
      );
      break;
    default:
      break;
  }

  return template;
}
